"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spaceOptions = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useControllableState = _interopRequireDefault(require("@ux/component-utilities/use-controllable-state"));
var _space = _interopRequireWildcard(require("@ux/space"));
const _excluded = ["as", "className", "children", "id", "name", "space", "stretch", "checked", "defaultChecked", "value", "onChange"];
/* eslint-disable no-process-env, no-console, complexity */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UX_CARD_CLASSNAME = 'ux-card';
function getTagName(as) {
  switch (as) {
    case 'checkbox':
    case 'radio':
      return _space.default.label;
    case 'link':
      return _space.default.a;
    case 'button':
      return _space.default.button;
    default:
      return _space.default.div;
  }
}

/**
 * Creates a card component
 *
 * @param {Object} props - Configuration object
 * @param {String} [props.as] - Determines the type of card
 * @param {String} [props.className] - Adds a class name to the card
 * @param {Node} props.children - Elements to exist within the card
 * @param {String} props.id - Unique identifier for the card
 * @param {String} [props.name] - Used to group input cards together
 * @param {Object} [props.space] - Used to configure the amount of space to apply around the card
 * @param {Boolean} [props.stretch] - Stretches width of container
 * @param {Boolean} [props.checked] - Used to mark input cards as selected
 * @param {Boolean} [props.defaultChecked] - Used to mark input cards as selected by default
 * @param {Node} [props.value] - Value assigned to the card
 * @param {Function} [props.onChange] - Used to fire when input card checked has changed
 * @param {Object} ref - Element reference
 * @returns {Element} - Card component
 */
const Card = /*#__PURE__*/_react.default.forwardRef(function Card() {
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let ref = arguments.length > 1 ? arguments[1] : undefined;
  let {
      as,
      className,
      children,
      id,
      name,
      space: spaceProps,
      stretch,
      checked: controllableProp,
      defaultChecked: defaultProp = false,
      value,
      onChange: onControllableChange = Function.prototype
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  // Style explicitly omitted, do not override
  delete rest.style;
  const TagName = getTagName(as);
  const isInput = ['checkbox', 'radio'].includes(as);
  const [checked, onChange] = (0, _useControllableState.default)({
    prop: controllableProp,
    defaultProp,
    onChange: onControllableChange
  });
  const _onChange = (0, _react.useCallback)(event => {
    onChange(event.target.checked, {
      event
    });
  }, [onChange]);
  let hiddenElem;
  if (isInput) {
    hiddenElem = /*#__PURE__*/_react.default.createElement("input", (0, _extends2.default)({
      type: as,
      name: name,
      id: id,
      ref: ref,
      "data-version": "2400",
      className: `${UX_CARD_CLASSNAME}-hidden`,
      checked: checked,
      onChange: _onChange,
      value: value
    }, rest));
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hiddenElem, /*#__PURE__*/_react.default.createElement(TagName, (0, _extends2.default)({
    ref: !isInput ? ref : null,
    htmlFor: isInput ? id : null,
    id: !isInput ? id : null,
    value: !isInput ? value : null,
    "data-version": "2400"
  }, spaceProps, {
    className: (0, _classnames.default)(`${UX_CARD_CLASSNAME}-shell`, className, {
      [`${UX_CARD_CLASSNAME}--stretch`]: stretch
    })
  }, isInput ? {} : rest), children));
});

/**
 * @type {Object}
 * @public
 */
const spaceOptions = exports.spaceOptions = _space.sizeOptions;
Card.propTypes = {
  /** Sets behavior of card */
  as: _propTypes.default.oneOf(['checkbox', 'radio', 'link', 'button']),
  /** Contents */
  children: _propTypes.default.node,
  /** Classes applied to component for positioning purposes */
  className: _propTypes.default.string,
  /** Unique identifier */
  id: _propTypes.default.string.isRequired,
  /** Named group (use in input) */
  name: _propTypes.default.string,
  /** Stretches width of container */
  stretch: _propTypes.default.bool,
  /** Space configuration object */
  space: _propTypes.default.shape({
    /** Sets spacing in the inline direction */
    inline: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(Object.values(_space.sizeOptions))]),
    /** Sets spacing in the block direction */
    block: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(Object.values(_space.sizeOptions))]),
    /** Deprecated, sets amount of space by type  */
    as: _propTypes.default.string
  }),
  /** Sets checked state for controlled input */
  checked: _propTypes.default.bool,
  /** Sets checked state for uncontrolled input */
  defaultChecked: _propTypes.default.bool,
  /** Sets value for the card */
  value: _propTypes.default.node,
  /** Fires when input card is checked/unchecked */
  onChange: _propTypes.default.func
};
var _default = exports.default = Card;